import React from "react";
import { Container } from "./styles";

function CssLoading() {
  return (
    <Container>
      <div className="loadingio-spinner-rolling-nzbf60oti2">
        <div className="ldio-frne5vp6d3f">
          <div></div>
        </div>
      </div>
    </Container>
  );
}

export default CssLoading;
